<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent scrollable max-width="600">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title
            class="black--text w-100 ta-c headline font-weight-bold"
            >แก้ไขการปลูกต้นไม้</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-container
              grid-list-md
              pa-0
              class="modal_loading"
              v-if="loading_save"
            >
            </v-container>
            <v-container grid-list-md pa-0>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 md12>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    color="blue"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFormatted"
                        readonly
                        prepend-inner-icon="event"
                        label="วันที่ปลูก*"
                        solo
                        hide-details
                        v-on="on"
                        color="blue"
                        @blur="date = parseDate(dateFormatted)"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="th"
                      v-model="date"
                      no-title
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center mb-2>
                <v-flex xs12 md12>
                  <span style="font-size: 18px;" class="font-weight-bold"
                    >สถานที่ปลูก</span
                  >
                  <v-radio-group
                    v-model="placetoSeed"
                    row
                    hide-details
                    style="margin-top:-10px"
                    :rules="nameRules"
                  >
                    <v-radio
                      label="ระบุพิกัดแปลงปลูกต้นไม้"
                      value="latlong"
                      hide-details
                    ></v-radio>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          fab
                          small
                          color="primary"
                          icon
                          :loading="loading"
                          @click="getGeolocation()"
                          style="margin-left: -10px;margin-right: 20px;"
                        >
                          <v-icon color="black">gps_fixed</v-icon>
                        </v-btn>
                      </template>
                      <span>ค้นหาตำแหน่งปัจจุบัน</span>
                    </v-tooltip>
                    <v-radio
                      label="ระบุที่อยู่แปลงปลูกต้นไม้่"
                      value="address"
                      hide-details
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <!-- address -->
              <div class="" v-if="placetoSeed === 'address'">
                <v-layout row wrap justify-center>
                  <v-flex xs12 md12>
                    <v-autocomplete
                      :items="listProvince"
                      label="จังหวัด*"
                      item-text="province_name"
                      item-value="province_id"
                      solo
                      hide-details
                      v-model="province_id"
                      @change="queryAmphoe()"
                      color="blue"
                      :rules="placetoSeed === 'address' ? nameRules : []"
                      return-object
                      ref="province"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="listAmphoe"
                      label="อำเภอ*"
                      solo
                      item-text="amphoe_name"
                      item-value="amphoe_id"
                      hide-details
                      v-model="amphoe_id"
                      @change="queryTambon()"
                      color="blue"
                      :disabled="province_id === '' ? true : false"
                      :rules="placetoSeed === 'address' ? nameRules : []"
                      return-object
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="listTambon"
                      label="ตำบล*"
                      solo
                      hide-details
                      v-model="tambon_id"
                      item-text="tambon_name"
                      item-value="tambon_id"
                      color="blue"
                      :disabled="amphoe_id === '' ? true : false"
                      :rules="placetoSeed === 'address' ? nameRules : []"
                      return-object
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </div>
              <!-- latlong -->
              <div class="" v-if="placetoSeed === 'latlong'">
                <v-layout row wrap justify-center>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="ละติจูด*"
                      v-model="latitude"
                      type="number"
                      solo
                      hide-details
                      :disabled="loading ? true : false"
                      :rules="placetoSeed === 'latlong' ? nameRules : []"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="ลองจิจูด*"
                      v-model="longitude"
                      solo
                      type="number"
                      hide-details
                      :disabled="loading ? true : false"
                      :rules="placetoSeed === 'latlong' ? nameRules : []"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row wrap justify-center>
                <v-flex md12 sm12 mt-3>
                  <span style="font-size: 18px;" class="font-weight-bold"
                    >รายละเอียดต้นไม้</span
                  >
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-autocomplete
                    :items="listPlant"
                    label="ต้นไม้ที่ปลูก*"
                    v-model="plant_id"
                    solo
                    item-text="plant_name"
                    item-value="plant_id"
                    hide-details
                    persistent-hint
                    color="blue"
                    :rules="nameRules"
                    required
                    ref="plant_name"
                    :menu-props="menuProps"
                  >
                    <template v-slot:no-data>
                      <v-list-tile @click="clickOther()">
                        <v-list-tile-title>
                          ไม้ยืนต้นอื่นๆ
                        </v-list-tile-title>
                      </v-list-tile>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="จำนวน*"
                    solo
                    hide-details
                    suffix="ต้น"
                    color="blue"
                    :mask="mask"
                    v-model="amount"
                    :rules="nameRules"
                    required
                    ref="amount"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center mt-2 pl-0>
                <v-flex xs12 md12 class="mt-3">
                  <span style="font-size:18px" class="font-weight-bold"
                    >ได้รับต้นไม้จาก*</span
                  >
                </v-flex>

                <v-flex xs12 md12>
                  <div class="mt-0">
                    <v-radio-group
                      class="mt-1"
                      hide-details
                      v-model="treeFromDepartment"
                      v-for="(i, index) in listDepartment"
                      :key="index"
                      :rules="nameRules"
                    >
                      <div :class="index == 0 ? 'for-rfd' : 'for-other'">
                        <v-radio
                          :label="i.department_name"
                          :value="i.department_id"
                          hide-details
                        ></v-radio>
                        <v-layout
                          row
                          wrap
                          v-show="index === 0"
                          v-if="treeFromDepartment === 1"
                          ><v-flex md12
                            >(โปรดระบุศูนย์/สถานี ที่ได้รับต้นไม้)</v-flex
                          >
                          <!-- <v-flex md6>
                            <v-autocomplete
                              :items="listSubDepartment"
                              label="พิมพ์ชื่อหน่วยงานย่อย"
                              v-model="subDepartment"
                              solo
                              item-text="department_name"
                              item-value="department_id"
                              hide-details
                              hide-selected
                              persistent-hint
                              color="blue"
                              :menu-props="menuProps"
                              clearable
                              @click:clear="onClearClickedSub"
                            ></v-autocomplete>
                          </v-flex> -->
                          <!-- {{ subSubDepartment }} -->
                          <v-flex md12>
                            <v-autocomplete
                              v-show="index === 0"
                              v-if="treeFromDepartment === 1"
                              :items="listSubSubDepartment"
                              label="พิมพ์ชื่อศูนย์/สถานี"
                              v-model="subSubDepartment"
                              solo
                              item-text="department_name"
                              item-value="department_id"
                              hide-details
                              hide-selected
                              persistent-hint
                              color="blue"
                              :menu-props="menuProps"
                              clearable
                              @click:clear="onClearClickedSubSub"
                              return-object
                              :rules="treeFromDepartment === 1 ? nameRules : ''"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-text-field
                            label="โปรดระบุ"
                            v-model="other"
                            solo
                            hide-details
                            v-if="index === 3"
                            :disabled="treeFromDepartment === 4 ? false : true"
                            class="other"
                            required
                            :rules="treeFromDepartment === 4 ? nameRules : []"
                          ></v-text-field>
                        </v-layout>
                      </div>
                    </v-radio-group>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row wrap mt-4>
            <span style="font-size: 18px;" class="font-weight-bold"
              >รายละเอียดเพิ่มเติม</span
            >
            <v-flex xs12 md12>
              <v-text-field
                label="บันทึก"
                v-model="note"
                solo
                hide-details
                :disabled="loading ? true : false"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="ta-c jc-c">
          <v-btn color="green darken-1" flat @click="dialog = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            color="primary"
            round
            @click="submit()"
            :disabled="loading ? true : false"
            :loading="loading_save"
            >บันทึก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { Decode } from "@/services";
import { handleAjaxError } from "@/utils/common";
export default {
  data() {
    return {
      disabled: false,
      dialog: false,
      dateFormatted: "",
      date: "",
      menu: false,
      imageName: "",
      listDepartment: [],
      listSubDepartment: [],
      listSubSubDepartment: [],
      treeFromDepartment: "",
      subDepartment: null,
      subSubDepartment: null,
      placetoSeed: "latlong",
      hasImage: false,
      image: null,
      mask: "#####",
      province_id: "",
      province_id_new: "",
      amphoe_id: "",
      amphoe_id_new: "",
      tambon_id: "",
      tambon_id_new: "",
      province_name: "",
      amphoe_name: "",
      tambon_name: "",
      attachment: [],
      listPlant: [],
      otherListPlant: [
        {
          plant_name: "อื่นๆ",
          plant_id: 126,
        },
      ],
      listProvince: [],
      listAmphoe: [],
      listTambon: [],
      latitude: "",
      latitude_new: "",
      longitude: "",
      longitude_new: "",
      plant_id: "",
      other: "",
      loading: false,
      amount: "",
      card_id: "",
      note: "",
      loading_save: false,
      nameRules: [(v) => !!v || "Name is required"],
      user_plant_id: "",
      listLatLng: "",
      check: false,
      menuProps: {
        closeOnClick: false,
        closeOnContentClick: true,
      },
    };
  },
  created() {
    var result = Decode.decode(this.$cookies.get("token"));
    this.card_id = JSON.parse(result).card_id;
    this.queryDepartment();
    this.queryPlant();
    this.queryProvince();
    this.querySubSubDepartment();
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    placetoSeed() {
      // console.log(this.placetoSeed);
      if (this.placetoSeed === "address") {
        this.province_id = this.province_id_new;
        this.queryAmphoe(this.province_id.province_id);
        this.amphoe_id = this.amphoe_id_new;
        this.queryTambon(this.amphoe_id.amphoe_id);
        this.tambon_id = this.tambon_id_new;
      } else {
        this.latitude = this.latitude_new;
        this.longitude = this.longitude_new;
        this.loading = false;
      }
    },
    treeFromDepartment() {
      // console.log("watch department");
      if (this.treeFromDepartment !== 4) {
        this.other = "";
      }

      if (this.treeFromDepartment != 1) {
        this.subSubDepartment = null;
      }

      // this.querySubDepartment(this.treeFromDepartment);
      // this.subDepartment = null;
    },
    // subDepartment() {
    //   // console.log("watch sub_department");
    //   if (this.subDepartment) {
    //     // var sub_d = this.subDepartment;
    //     // console.log(sub_d);
    //     this.querySubSubDepartment(this.subDepartment);
    //   } else {
    //     this.subSubDepartment = null;
    //     this.subDepartment = null;
    //   }
    // },
  },
  methods: {
    // onClearClickedSub() {
    //   this.subDepartment = null;
    //   this.subSubDepartment = null;
    // },
    onClearClickedSubSub() {
      this.subSubDepartment = null;
    },
    clickOther() {
      this.plant_id = "";
      this.$refs.form.resetValidation();
      this.plant_id = 126;
      // setTimeout(() => this.plant_id = 126, 10)
    },
    getGeolocation() {
      this.loading = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.getPositionErrorHandle,
          {
            timeout: 10000,
            enableHighAccuracy: true,
            maximumAge: 0,
          }
        );
      }
    },
    showPosition(position) {
      // console.log(position);
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.loading = false;
    },
    getPositionErrorHandle(positionError) {
      switch (positionError.code) {
        case 1: //PERMISSION_DENIED
          this.$swal(
            "กรุณาเปิดสิทธิ์การเข้าถึงที่อยู่ของท่านบนบราวเซอร์",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
          this.loading = false;
          break;
        case 2: //POSITION_UNAVAILABLE
          this.$swal(
            "ระบบไม่สามารถหาตำแหน่งได้",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
          this.loading = false;
          break;
        case 3: //TIMEOUT
          this.$swal(
            "ระบบใช้เวลาค้นหาเกินกำหนด",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
          this.loading = false;
          break;
        default:
      }
    },
    queryDepartment() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryDepartment")
        .then((response) => {
          this.listDepartment = response.data;
        });
    },
    // querySubDepartment(sub_id) {
    //   this.axios
    //     .post(process.env.VUE_APP_IPFLASK + "/querySubDepartment", {
    //       sub_department_id: sub_id,
    //     })
    //     .then((response) => {
    //       // console.log(response.data);
    //       if (response.data.length !== 0) {
    //         this.listSubDepartment = response.data;
    //         if (this.subDepartment !== null) {
    //           this.querySubSubDepartment(this.subDepartment);
    //         }
    //       }
    //     });
    // },
    querySubSubDepartment() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/querySubSubDepartment")
        .then((response) => {
          // console.log(response.data);
          if (response.data.length !== 0) {
            this.listSubSubDepartment = response.data;
            // console.log(this.listSubSubDepartment);
          }
        });
    },
    queryPlant() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryPlant")
        .then((response) => {
          // console.log(response.data);
          this.listPlant = response.data;
        });
    },
    queryProvince() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryProvince")
        .then((response) => {
          this.listProvince = response.data;
        });
    },
    queryAmphoe() {
      this.tambon_id = "";
      this.amphoe_id = "";
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryAmphoe", {
          province_id: this.province_id.province_id,
        })
        .then((response) => {
          this.listAmphoe = response.data;
        });
    },
    queryTambon() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryTambon", {
          amphoe_id: this.amphoe_id.amphoe_id,
        })
        .then((response) => {
          this.listTambon = response.data;
        });
    },
    openDialog(
      date_planting,
      plant_id,
      user_plant_id,
      amount,
      latitude,
      longitude,
      province_id,
      province_name,
      amphoe_id,
      amphoe_name,
      tambon_id,
      tambon_name,
      department_id,
      sub_department_id_level2,
      sub_department_name_level2,
      parent_department_id,
      other,
      note
    ) {
      this.dialog = true;
      this.loading_save = false;
      this.$refs.form.resetValidation();
      this.date = date_planting;
      // console.log(this.date);
      this.plant_id = plant_id;
      this.amount = amount;
      this.province_id = {
        province_id: province_id,
        province_name: province_name,
      };
      this.province_id_new = {
        province_id: province_id,
        province_name: province_name,
      };
      this.queryAmphoe(this.province_id.province_id);
      this.amphoe_id = {
        amphoe_id: amphoe_id,
        amphoe_name: amphoe_name,
        province_id: province_id,
      };
      this.amphoe_id_new = {
        amphoe_id: amphoe_id,
        amphoe_name: amphoe_name,
        province_id: province_id,
      };
      this.queryTambon(this.amphoe_id.amphoe_id);
      this.tambon_id = {
        tambon_id: tambon_id,
        tambon_name: tambon_name,
        amphoe_id: amphoe_id,
      };
      this.tambon_id_new = {
        tambon_id: tambon_id,
        tambon_name: tambon_name,
        amphoe_id: amphoe_id,
      };
      this.latitude = latitude;
      this.latitude_new = latitude;
      this.longitude = longitude;
      this.longitude_new = longitude;
      this.treeFromDepartment = department_id;
      // this.subDepartment = sub_department_id_level1;
      this.subSubDepartment = {
        department_id: sub_department_id_level2,
        department_name: sub_department_name_level2,
        parent_department_id: parent_department_id,
      };
      this.other = other;
      this.note = note;
      this.user_plant_id = user_plant_id;
      this.placetoSeed = "latlong";
      this.check = false;
      this.loading = false;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      var year_thai = parseInt(year) + 543;
      return `${day}/${month}/${year_thai}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      var year_2 = parseInt(year) - 543;
      return `${year_2}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async submit() {
      this.loading_save = true;
      if (this.$refs.form.validate()) {
        if (this.placetoSeed === "address") {
          // console.log(this.tambon_id);
          this.latitude = this.tambon_id.latitude;
          this.longitude = this.tambon_id.longitude;
          // console.log(this.latitude);
          // console.log(this.longitude);
          // add randomness
          // calculated from https://msi.nga.mil/MSISiteContent/StaticFiles/Calculators/degree.html
          const latMetersPerDegree = 110647.5;
          const lngMetersPerDegree = 107571;
          const maxRandomOffsetMeters = 1000;
          const latMaxOffset = maxRandomOffsetMeters / latMetersPerDegree;
          const lngMaxOffset = maxRandomOffsetMeters / lngMetersPerDegree;
          const latOffset = Math.random() * latMaxOffset - latMaxOffset / 2;
          const lngOffset = Math.random() * lngMaxOffset - lngMaxOffset / 2;
          this.latitude = this.latitude + latOffset;
          this.longitude = this.longitude + lngOffset;
        }
        if (this.treeFromDepartment !== 1) {
          this.subDepartment = null;
          this.subSubDepartment = null;
        }
        var formData = new FormData();
        formData.append("card_id", this.card_id);
        formData.append("date", this.date);
        formData.append("plant_id", this.plant_id);
        formData.append("amount", this.amount);
        formData.append("province_id", this.province_id.province_id);
        formData.append("amphoe_id", this.amphoe_id.amphoe_id);
        formData.append("tambon_id", this.tambon_id.tambon_id);
        formData.append("latitude", this.latitude);
        formData.append("longitude", this.longitude);
        formData.append("other", this.other);
        formData.append("note", this.note);
        formData.append("treeFromDepartment", this.treeFromDepartment);
        if (this.treeFromDepartment == 1) {
          formData.append(
            "subDepartment",
            this.subSubDepartment.parent_department_id
          );
          formData.append(
            "subSubDepartment",
            this.subSubDepartment.department_id
          );
        } else {
          formData.append("subDepartment", this.subSubDepartment);
          formData.append("subSubDepartment", this.subSubDepartment);
        }
        formData.append("placetoSeed", this.placetoSeed);
        formData.append("user_plant_id", this.user_plant_id);
        // for (var pair of formData.entries()) {
        //   console.log(pair[0]+ ', ' + pair[1]);
        // }
        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/updatePlant", formData)
          .then((response) => {
            if (response.data === "Update Success") {
              this.dialog = false;
              this.$swal("แก้ไขการปลูกต้นไม้เรียบร้อย", "", "success");
              this.date = "";
              this.plant_id = "";
              this.amount = "";
              this.province_id = "";
              this.amphoe_id = "";
              this.tambon_id = "";
              this.latitude = "";
              this.longitude = "";
              this.treeFromDepartment = "";
              this.subDepartment = "";
              this.subSubDepartment = "";
              this.placetoSeed = "latlong";
              this.other = "";
              this.note = "";
              this.loading_save = false;
              this.$emit("fetch", true);
            }
          })
          .catch((error) => handleAjaxError(error, this));
      } else {
        this.$swal("กรุณากรอกข้อมูลให้ครบถ้วน", "", "error");
        this.check = true;
        this.loading_save = false;
      }
    },
  },
};
</script>

<style scoped>
.border-upload {
  border: 2px solid #c4c4c4;
  justify-content: center;
  display: flex;
  align-items: center;
  border-radius: 5px;
}
.border-upload-warning {
  border: 2px solid red;
  justify-content: center;
  display: flex;
  align-items: center;
  border-radius: 5px;
}

#upload_tree .v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent !important;
}

.modal_loading {
  position: absolute;
  background: #4e4e4e70;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}

.for-rfd {
  display: flex !important;
  flex-flow: column !important;
}

.for-other {
  display: flex !important;
}
</style>
